<template>
    <div class="container-fluid p-3 p-md-4">

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-4 mb-md-5">
            <h3 class="font-weight-600 text-dark mb-0">
                <i class="fa-duotone fa-list-check text-primary fa-fw mr-3"/>Nový incident
            </h3>
            <div class="buttons mt-3 mt-md-0">
                <PrimaryLinkButton
                    to="/worker/incidents"
                    icon="fad fa-chevron-circle-left"
                    text="Vytvořit nový incident"
                />
            </div>
        </div>

        <div class="p-4 bg-little-gray">
            <IncidentForm/>
        </div>

    </div>
</template>

<script>
import IncidentForm from "./Component/IncidentForm.vue"
import PrimaryLinkButton from "../../Common/UI/Button/PrimaryLinkButton.vue"

export default {

    components: {
        IncidentForm,
        PrimaryLinkButton,
    },

}
</script>
